import { SQ_METERS_PER_SQ_MILE } from '../../shared/constants';

const SQ_M_PER_ACRE = 4046.8564224;

/** Zone area for display: mi² to two decimals, switching to acres below
 *  0.05 mi² so the digit keeps meaning (§11.2 / Cockpit). */
export function formatArea(sqMeters: number): { value: string; unit: string } {
  const mi2 = sqMeters / SQ_METERS_PER_SQ_MILE;
  if (mi2 >= 0.05) return { value: mi2.toFixed(2), unit: 'mi²' };
  const acres = sqMeters / SQ_M_PER_ACRE;
  return { value: acres < 10 ? acres.toFixed(1) : String(Math.round(acres)), unit: 'ac' };
}

export const formatAreaStr = (sqMeters: number): string => {
  const a = formatArea(sqMeters);
  return `${a.value} ${a.unit}`;
};

/** mm:ss from milliseconds (floored). Use for ELAPSED / final-score times, where
 *  "held 12:00" means twelve full minutes have passed. */
export function formatClock(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

/** mm:ss for a live COUNTDOWN, rounded UP: "0:01" shows while up to one second
 *  remains and "0:00" appears exactly at expiry — where a floor would show "0:00"
 *  for the whole final second while real time is still on the clock (the moment a
 *  hider is timing). Pair with useServerClock(deadline) so the digit also flips
 *  ON the second. Use for endsAt-driven deadlines; keep formatClock for elapsed. */
export function formatCountdown(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

/** Distance in feet, rounded — operational copy is numbers over adjectives. */
export const metersToFeet = (m: number): number => Math.round(m * 3.280839895);

/** Pressure scale (§11.2): Bone → Hazard → Moss → Signal at 33/66/90%. */
export function pressureColor(p: number): string {
  if (p < 0.33) return 'var(--bone)';
  if (p < 0.66) return 'var(--hazard)';
  if (p < 0.9) return 'var(--moss)';
  return 'var(--signal)';
}
